<template>
  <div
    class="ma-2"
    :style="{ border: `1px solid ${colors.blue.base}` }"
    style="border-radius: 5px"
  >
    <div
      class="pa-2"
      :style="{
        borderBottom: `1px solid ${colors.blue.base}`,
        backgroundColor: colors.blue.lighten4
      }"
    >
      <v-layout>
        <v-flex>
          <div
            v-if="bundle"
            class="pa-1 caption orange--text"
            style="border-radius: 5px; display: inline-block"
            :style="{
              'background-color': colors.orange.lighten5,
              border: `1px solid ${colors.orange.base}`
            }"
          >
            {{
              `ซื้อ ${bundle.quantity_condition} ชิ้น ลด ${bundle.discount} บาท`
            }}
          </div>
        </v-flex>
        <v-flex shrink>
          <slot name="title-append"></slot>
        </v-flex>
      </v-layout>
    </div>

    <slot></slot>
  </div>
</template>

<script>
import colors from 'vuetify/es5/util/colors'
export default {
  props: {
    bundle: {
      default: {}
    }
  },
  data() {
    return {
      colors: colors
    }
  }
}
</script>

<style lang="scss" scoped></style>
